<section class="pageTitle tAlignCenter">
  <p class="darkGreyT w300 tAlignCenter">Scan QR code in your authenticator app and verify in the input below.</p>
  <hr class="darkWhiteBG marTop20 marBot20 opat25" />
  <p class="tAlignCenter"><img class="qr-image" src="/auth/my_qr_code.svg" /></p>
  @if (backend && partialToken) {
  <form
    #mfaVerifyForm
    (ngSubmit)="mfaVerifyForm.submit()"
    [action]="
      stateService.nextPath
        ? '/auth/complete/' + backend + '/?next=' + stateService.nextPath
        : '/auth/complete/' + backend + '/'
    "
    method="post"
    role="form"
  >
    <input type="hidden" name="partial_token" value="{{ partialToken }}" />
    <label class="marTop40 oneColumn">
      <input
        type="text"
        id="mfaVerify"
        name="mfa_verify"
        class="field auth-field lightGreyBG50"
        [class.is-empty]="!mfaVerify"
        [(ngModel)]="mfaVerify"
        required
      />
      <span>
        <span class="dFlex justifyContentCenter">
          <fa-icon [icon]="['fas', 'mobile-alt']" class="marRight5"></fa-icon> Authenticator Token<em class="required"
            >*</em
          >
        </span>
      </span>
    </label>
    <section class="buttonGroupBottom tAlignCenter clearfix">
      <button
        class="button primary radius primaryBorder noMar marTop20 left width100"
        (click)="mfaVerifyForm.submit()"
        type="submit"
      >
        <fa-icon [icon]="['far', 'badge-check']"></fa-icon> Submit
      </button>
    </section>
  </form>
  }
</section>
